module.exports = __webpack_public_path__ + "images/IPOde71b98abcae4eba75d31c2b961a7c1a.png";